import { Modal } from "antd";
import { sendUrgentShiftCancelEvent } from "./sendUrgentShiftCancelEvent";
import { Shift } from "src/interface";
import { CancelActionType } from "./constants";

export type UrgentShiftCancelEventShift = Pick<
  Shift,
  | "_id"
  | "agent"
  | "agentId"
  | "start"
  | "facility"
  | "instantPayDetails"
  | "agentReq"
  | "facilityId"
>;

interface IUrgentShiftCancelProps {
  shift: UrgentShiftCancelEventShift;
  onKeepShift?: () => void;
  onCancelShift?: () => void;
}
function UrgentShiftCancelModel({ shift, onKeepShift, onCancelShift }: IUrgentShiftCancelProps) {
  const keepShiftEvent = async () => {
    await sendUrgentShiftCancelEvent(shift, CancelActionType.KEEP_SHIFT);
    if (onKeepShift) {
      onKeepShift();
    }
  };

  const cancelShiftEvent = async () => {
    await sendUrgentShiftCancelEvent(shift, CancelActionType.CANCEL_SHIFT);
    if (onCancelShift) {
      onCancelShift();
    }
  };

  return (
    <Modal
      title="We are working on finding a replacement for this shift"
      visible={true}
      okText={"Keep the Shift"}
      cancelText={"Cancel the Shift"}
      onOk={keepShiftEvent}
      onCancel={cancelShiftEvent}
      closable={false}
      keyboard={false}
    >
      <p>
        We have identified this shift as a potential no show and we are actively working on finding
        a replacement urgently.
      </p>
    </Modal>
  );
}

export { UrgentShiftCancelModel };
